<template>
    <v-text-field v-model="localUrl" class="mt-3"
                  :label="$t('EnterUrl')"
                  outlined
                  dense
                  placeholder="Enter website URL"
                  :rules="urlRules"
      @blur="prependHttp"></v-text-field>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                // Local copy of the URL for the text field
                localUrl: this.value,
                urlRules: [
                    v => !!v || this.$t('RequiredField'),
                    v => /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?[^\s]*)?$/i.test(v) || this.$t('InvalidUrl')
                ]
            }
        },
        methods: {
            prependHttp() {
                if (this.localUrl && !this.localUrl.startsWith('http://') && !this.localUrl.startsWith('https://')) {
                    this.localUrl = 'http://' + this.localUrl
                }
            },
        },
        watch: {
            localUrl(newValue) {
                this.$emit('input', newValue)
            },
            value(newValue) {
                this.localUrl = newValue
            }
        }
    }
</script>
